import React from "react";
import { useTranslation } from "react-i18next";

const BannerHome = () => {
  const { t } = useTranslation();

  return (
    <section>
      <div className="banner-home">
        <video
          autoPlay
          loop
          muted
          playsInline
          width="100%"
          poster="../../assets/img/video-home.webp"
        >
          <source
            src="../../assets/video/video-home.mp4"
            type="video/mp4"
          />
          Tu navegador no soporta video.
        </video>
        <h1>{t("home.bannerTitle")}</h1>
      </div>
    </section>
  );
};

export default BannerHome;
